import React from 'react'
import './styles/input.css';

export default function Input({type, value, handleChange, placeholder, style, className, maxLength}) {
    return (
        <input type={type}
               className={className}
               value={value}
               style={style}
               onChange={handleChange}
               placeholder={placeholder}
               maxLength={maxLength}/>
    )
}
